import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../hooks/redux";
import Button from "../../components/ui/Button";

const PaymentSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(true);
  // Source of truth for login state (Redux auth slice, hydrated from localStorage).
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const isFree = searchParams.get("free") === "true";

  useEffect(() => {
    const sessionId = searchParams.get("session_id");

    if (!sessionId) {
      setIsProcessing(false);
      return;
    }

    // Simulate processing time before redirect
    const timer = setTimeout(() => {
      setIsProcessing(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [searchParams]);

  const handleGoToDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 bg-neutral-50">
      <div className="w-full max-w-md p-8 bg-white border rounded-lg shadow-sm border-neutral-200">
        {isProcessing ? (
          <div className="space-y-4 text-center">
            <div className="w-8 h-8 mx-auto border-2 rounded-full border-neutral-200 border-t-primary-700 animate-spin" />
            <h2 className="text-lg font-semibold text-black">
              Processing your payment...
            </h2>
            <p className="text-sm text-neutral-600">
              Please wait while we confirm your subscription
            </p>
          </div>
        ) : (
          <div className="space-y-6 text-center">
            <div className="flex items-center justify-center w-16 h-16 mx-auto rounded-full bg-success-100">
              <svg
                className="w-10 h-10 text-success-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <div>
              <h2 className="text-2xl font-semibold tracking-tight text-black">
                {isFree ? "Subscription Activated!" : "Payment Successful!"}
              </h2>
              <p className="mt-2 text-sm text-neutral-600">
                {isFree
                  ? "Thank you! Your subscription has been activated successfully."
                  : "Thank you for your subscription. Your payment has been processed successfully."}
              </p>
            </div>
            <div className="p-4 border rounded-md bg-neutral-50 border-neutral-200">
              <p className="text-sm text-neutral-600">
                {isAuthenticated
                  ? "Your subscription is now active and you can start using all the premium features."
                  : "Your subscription is now active. Log in to your account to start using all the premium features. If this is your first time, check your email to set your password."}
              </p>
            </div>
            {isAuthenticated && (
              <Button
                onClick={handleGoToDashboard}
                className="w-full"
              >
                Go to Dashboard
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
